import styled, { css } from 'styled-components/macro'

import Icon from '../../../atoms/Icon/Icon';

import { settings } from '../../../../styled/settings/index';
import { mixins } from '../../../../styled/mixins/index';
import { mobile } from '../../../../styled/settings/mediaqueries';

const {
  colors: { color, hexToRGBa },
  fonts: { brandonGrotesqueMedium },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletLandscapeUp, tabletPortraitDown, tabletPortraitUp },
  sizing: { fontsize, spacingsize, radiussize },
  shadows: { buttonShadowDefault },
} = settings;

const {
  typography: { buttonText },
} = mixins;

const iconButtonStyles = css`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 30px;
`;

export const OpenNavigationLinkIcon = styled(Icon)`
  ${iconButtonStyles}
  height: 20px;
  width: 20px;
  float: right;
  font-weight: bold;
  
  g, rect, path, polygon {
    fill: ${color(`white`)};
  }
`;

export const CloseNavigationLinkIcon = styled(Icon)`
  ${iconButtonStyles}
  height: 20px;
  width: 20px;
  float: right;
  font-weight: bold;
  
  g, rect, path, polygon {
    fill: ${color(`white`)};
  }
`;

const navigationItemSpacing = spacingsize(7);

export const SubNavigationContainer = styled.div`
  z-index: 1;
  padding: 0;
  padding-left: ${navigationItemSpacing};
`;

export const SubNavigation = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const Item = styled.li`
  position: relative;
  list-style: none;
  display: block;
  padding: ${navigationItemSpacing} 0 ${navigationItemSpacing} 0;
  margin: 0 ${navigationItemSpacing} 0 ${navigationItemSpacing};
  border-bottom: solid 2px ${hexToRGBa(color(`teal`), 0.5)};

  &:first-child {
    border-top: solid 2px ${hexToRGBa(color(`teal`), 0.5)};
  }

  &:hover div[data-subnavigation] {
    display: block;
  }
`;

export const SubNavigationItem = styled.li`
  position: relative;
  width: 100%;
  list-style: none;
  display: block;
  padding: ${navigationItemSpacing};
`;

export const navigationItemsText = css`
  ${brandonGrotesqueMedium}
  text-transform: uppercase;
  font-size: ${fontsize(6)};

  @media ${tabletLandscapeDown} {
    font-size: ${fontsize(5)};
  }

  @media ${tabletPortraitDown} {
    font-size: ${fontsize(5)};
  }

  @media ${mobileDown} {
    font-size: ${fontsize(5)};
  }
`;

export const NavigationLink = styled.a`
  ${navigationItemsText}
  text-decoration: none;
  color: ${color(`white`)};
  -webkit-transition: color 1.5s; /* For Safari 3.0 to 6.0 */
  transition: color 1.5s; /* For modern browsers */

  &:hover {
    color: ${color(`teal`)};

    ${SubNavigation} {
      display: block;
    }
  }
`;

export const SubNavigationLink = styled.a`
  ${navigationItemsText}
  text-decoration: none;
  color: ${color(`teal`)};
  -webkit-transition: color 1.5s; /* For Safari 3.0 to 6.0 */
  transition: color 1.5s; /* For modern browsers */

  &:hover {
    color: ${color(`white`)};
  }
`;